// extracted by mini-css-extract-plugin
export default {"panel":"panel_panel__8RITT","groups":"panel_groups__WsYrL","items":"panel_items__q+WN6","active":"panel_active__0Kz20"};